import angular from "angular";
import utilService from './util.service';

let utilModule = angular.module('util.service', [])
.service('Util', utilService)

.name;

export default utilModule;



// WEBPACK FOOTER //
// ./client/app/services/utilService/util.js